export class ContactUser{
    pix: number;
    s_cont: number;
    s_pc: number;
    ix: number;
    code: string;
    name: string;
    street1: string;
    zip: number;
    city: string;
    state: string;
    phone1: string;
    phone2: string;
    phone3: string;
    email1: string;
    email2: string;
    email_flg: number;
    push_flg: number;
    seq: number;
    lix: string;
    ilevel: number;
    type: number;

    constructor(){
        this.pix = 0;
        this.s_cont = 0;
        this.s_pc = 0;
        this.ix = 0;
        this.code = '';
        this.name = '';
        this.street1 = '';
        this.zip = 0;
        this.city = '';
        this.state = '';
        this.phone1 = '';
        this.phone2 = '';
        this.phone3 = '';
        this.email1 = '';
        this.email2 = '';
        this.email_flg = 0;
        this.push_flg = 0;
        this.seq = 0;
        this.lix = '';
        this.ilevel = 0;
        this.type = 0;
    }
}